module.exports = __webpack_public_path__ + "img/apple-touch-icon-72x72.15d26560.png";